var React = require('react');

function AmexLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m16 .938h-2.502l-.585.63-.546-.63h-5.383l-.463 1.064-.474-1.064h-4.241l-1.806 4.124h2.162l.267-.658h.613l.267.658h8.984l.602-.641.563.641h2.542l-1.811-2.051zm-7.445 3.544h-.697l-.006-2.318-1.02 2.318h-.624l-1.025-2.318v2.318h-1.438l-.273-.663h-1.471l-.273.663h-.769l1.265-2.959h1.053l1.198 2.798v-2.798h1.154l.925 2.006.853-2.006h1.148zm6.119 0h-.908l-.869-.981-.903.981h-2.798v-2.959h2.842l.869.97.897-.97h.869l-1.321 1.488zm-3.004-2.346.774.864-.808.869h-1.739v-.591h1.549v-.602h-1.549v-.541h1.773zm-8.934-.111.485 1.181h-.97z"}));
}

AmexLogo.defaultProps = {"height":"6","viewBox":"0 0 16 6","width":"16"};

module.exports = AmexLogo;

AmexLogo.default = AmexLogo;
